export function generateDefaultPseudo(smartuserId: string): string {
  const shortId = smartuserId.replace(/-/g, '').substring(0, 8);
  return `user${shortId}`;
}
